export const getChateauneufDuPapeData = () => ({
  name: "Châteauneuf-du-Pape",
  region: "Rhône",
  country: "France",
  description: "Châteauneuf-du-Pape est l'appellation la plus prestigieuse du Rhône méridional, produisant des vins rouges puissants et complexes avec jusqu'à 13 cépages autorisés.",
  type: "subregion",
  area: "3,200 ha",
  production: "120,000 hectolitres",
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat méditerranéen chaud et sec",
    soil: "Sols de galets roulés, argile et calcaire",
    viticulture: "Viticulture traditionnelle, rendements limités, galets roulés caractéristiques"
  },
  wineStyles: {
    red: "Vins rouges puissants et complexes, avec des notes de fruits mûrs et d'épices",
    white: "Vins blancs riches et aromatiques, avec des notes de fruits exotiques"
  },
  history: "Châteauneuf-du-Pape produit des vins depuis l'époque des papes d'Avignon au XIVe siècle. L'appellation est reconnue depuis 1936. C'est l'une des premières AOC de France.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine provençale",
  grapeVarieties: [
    {
      name: "Grenache",
      percentage: "65%",
      description: "Cépage principal de Châteauneuf-du-Pape, produisant des vins puissants et fruités avec un alcool élevé",
      characteristics: "Puissant, fruité, alcool élevé, notes de fruits rouges mûrs, épices douces",
      wineStyles: "Sec, plein-corps, fruité, chaleureux"
    },
    {
      name: "Syrah",
      percentage: "15%",
      description: "Cépage d'assemblage majeur, apportant structure, couleur et complexité aromatique",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs, poivre, violette",
      wineStyles: "Sec, plein-corps, tannique, complexe"
    },
    {
      name: "Mourvèdre",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant complexité, capacité de garde et notes animales",
      characteristics: "Complexe, tannique, notes d'épices, fruits noirs, cuir, gibier",
      wineStyles: "Sec, plein-corps, tannique, de garde"
    },
    {
      name: "Cinsault",
      percentage: "3%",
      description: "Cépage d'assemblage, apportant élégance, fruité et fraîcheur",
      characteristics: "Élégant, fruité, tanins doux, notes de fruits rouges frais",
      wineStyles: "Sec, moyen-corps, fruité, élégant"
    },
    {
      name: "Counoise",
      percentage: "2%",
      description: "Cépage rare d'assemblage, apportant fraîcheur et notes florales",
      characteristics: "Frais, aromatique, notes florales, acidité vive",
      wineStyles: "Sec, moyen-corps, aromatique, frais"
    },
    {
      name: "Muscardin",
      percentage: "1%",
      description: "Cépage très rare, apportant des notes aromatiques uniques",
      characteristics: "Aromatique, notes de musc, épices douces, élégant",
      wineStyles: "Sec, moyen-corps, aromatique, élégant"
    },
    {
      name: "Vaccarèse",
      percentage: "1%",
      description: "Cépage rare, apportant finesse et notes herbacées",
      characteristics: "Fin, notes herbacées, tanins doux, élégant",
      wineStyles: "Sec, moyen-corps, fin, élégant"
    },
    {
      name: "Terret Noir",
      percentage: "1%",
      description: "Cépage rare, apportant fraîcheur et légèreté",
      characteristics: "Frais, léger, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, léger, fruité, frais"
    },
    {
      name: "Picardan",
      percentage: "1%",
      description: "Cépage très rare, apportant des notes minérales",
      characteristics: "Minéral, frais, notes de pierre à fusil, élégant",
      wineStyles: "Sec, moyen-corps, minéral, élégant"
    },
    {
      name: "Grenache Blanc",
      percentage: "1%",
      description: "Cépage blanc principal pour les vins blancs de Châteauneuf-du-Pape",
      characteristics: "Riche, aromatique, notes de fruits exotiques, miel",
      wineStyles: "Sec, plein-corps, aromatique, riche"
    },
    {
      name: "Roussanne",
      percentage: "0.5%",
      description: "Cépage blanc d'assemblage, apportant complexité et notes florales",
      characteristics: "Complexe, notes florales, miel, épices douces",
      wineStyles: "Sec, plein-corps, complexe, aromatique"
    },
    {
      name: "Clairette",
      percentage: "0.3%",
      description: "Cépage blanc traditionnel, apportant fraîcheur et acidité",
      characteristics: "Frais, acidité vive, notes d'agrumes, minéral",
      wineStyles: "Sec, moyen-corps, frais, minéral"
    },
    {
      name: "Bourboulenc",
      percentage: "0.2%",
      description: "Cépage blanc rare, apportant finesse et notes d'amande",
      characteristics: "Fin, notes d'amande, minéral, élégant",
      wineStyles: "Sec, moyen-corps, fin, élégant"
    }
  ]
}); 